import styled from 'styled-components';

export const BreadCrumbsRoot = styled.span`
    word-wrap: break-word;
`;
